import {Component, Input} from '@angular/core';
import {NgClass, NgIf, NgStyle} from "@angular/common";

@Component({
    selector: 'app-task-status-icon',
    standalone: true,
    imports: [
        NgClass,
        NgIf,
        NgStyle
    ],
    templateUrl: './task-status-icon.component.html',
    styleUrl: './task-status-icon.component.scss'
})
export class TaskStatusIconComponent {

    @Input() status: 'open' | 'progress' | 'review' | 'done' | 'blocked' = 'open';
    @Input() size: string = '1';

    get statusName(): string {
        switch (this.status) {
            case 'progress':
                return 'bg-yellow-400 status-icon';
            case 'open':
                return 'bg-red-400 status-icon';
            case 'review':
                return 'bg-white status-icon';
            case 'done':
                return 'pi pi-check-circle text-green-600 text-lg font-bold';
            case 'blocked':
                return 'pi pi-times-circle text-red-600 text-lg font-bold';
            default:
                return 'bg-red-400 status-icon';
        }
    }

    get circleSize() {
        return `${this.size}rem`;
    }
}
